import React from "react";
import { NavLink } from "react-router-dom";
import { Home, CalendarHeart, Sparkles, MessageCircle, UserCircle2, Baby } from "lucide-react";

const tabs = [
  { to: "/",          label: "Today",    icon: Home,          testid: "bottom-tab-home" },
  { to: "/cycle",     label: "Cycle",    icon: CalendarHeart, testid: "bottom-tab-cycle" },
  { to: "/pregnancy", label: "Baby",     icon: Baby,          testid: "bottom-tab-pregnancy" },
  { to: "/wellness",  label: "Wellness", icon: Sparkles,      testid: "bottom-tab-wellness" },
  { to: "/coach",     label: "Coach",    icon: MessageCircle, testid: "bottom-tab-coach" },
  { to: "/profile",   label: "You",      icon: UserCircle2,   testid: "bottom-tab-profile" },
];

export default function BottomTabs() {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40 bottom-tabs-fixed px-2 pt-2 pb-1"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 8px)" }}
      data-testid="bottom-tabs"
    >
      <ul className="flex items-center justify-between">
        {tabs.map(({ to, label, icon: Icon, testid }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={to === "/"}
              data-testid={testid}
              className="flex flex-col items-center justify-center w-full py-1 gap-1"
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`flex items-center justify-center h-10 w-10 rounded-2xl transition-all duration-200 ${
                      isActive
                        ? "bg-primary text-primary-foreground shadow-[var(--shadow-soft)]"
                        : "text-foreground/55 hover:text-foreground hover:bg-muted/60"
                    }`}
                  >
                    <Icon size={18} strokeWidth={2.4} />
                  </span>
                  <span
                    className={`text-[9px] font-extrabold tracking-wider uppercase leading-none transition-colors ${
                      isActive ? "text-primary" : "text-foreground/50"
                    }`}
                  >
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
